import { Col, Row } from 'antd';
import { AxiosError } from 'axios';
import ButtonComponent from 'components/atoms/ButtonComponent';
// import ButtonComponent from 'components/atoms/ButtonComponent';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import TranslateText from 'components/hoc/TranslateText';
import StatementWrapper from 'components/molecules/StatementWrapper';
import routePathEnum from 'enums/routePathEnum';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { IZadostDataNU, nuZadostApi } from 'services/nezarazenyUcet/nuDedictvi';
import Prehled from './Prehled';
import IDEN from './stavPages/IDEN';
import OBJED from './stavPages/OBJED';
import PLODLO from './stavPages/PLODLO';
import PLZAPL from './stavPages/PLZAPL';
import PLZRUS from './stavPages/PLZRUS';
import VypisKontaktniUdaje from './VypisKontaktniUdaje';

interface IVypisUvod {}

const Zadost: React.FC<IVypisUvod> = () => {
    const history = useHistory();
    const [loading, setLoading] = useState<boolean>(false);
    const [stav, setStav] = useState<string>('IDEN');
    const [zadostData, setZadostData] = useState<IZadostDataNU>();
    const [errStatus, setErrStatus] = useState<number>();
    const { token } = useParams<{ token: string }>(); // token sebran z urlky

    const routeChange = () => {
        let path = zadostData?.idzadosti
            ? '/nezarazeny-ucet-zjisteni/bankid/' + zadostData.idzadosti
            : '/nezarazeny-ucet-zjisteni/bankid';
        history.push(path);
    };

    useEffect(() => {
        setLoading(true);
        token
            ? nuZadostApi(token)
                  // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  .then((resp: any) => {
                      setZadostData(resp);
                      setStav(resp.stav);
                      setLoading(false);
                  })
                  .catch((err: AxiosError) => {
                      setErrStatus(err.response?.status);
                      setLoading(false);
                  })
            : history.push(routePathEnum.VYPIS_BANKID_NOID); // Pokud nebude na konci url token dojde k redirectu uživatele zpět na stránku s loginem do bankid
    }, [stav, setStav, token, history]);
    return (
        <StatementWrapper pageTitle="">
            <LoadingWrapper loading={loading}>
                {errStatus ? (
                    <Col span={24}>
                        <Row>
                            {errStatus === 400 ? (
                                <Title text="RESPONSE_ERROR_400" level={3} />
                            ) : errStatus === 401 ? (
                                <Title text="RESPONSE_ERROR_401" level={3} />
                            ) : errStatus === 404 ? (
                                <Title text="RESPONSE_ERROR_404" level={3} />
                            ) : errStatus === 500 ? (
                                <Title text="RESPONSE_ERROR_500" level={3} />
                            ) : errStatus ? (
                                <Title text="SLUZBA_NEDOSTUPNA" level={3} />
                            ) : null}
                        </Row>

                        <Row className="statement-buttons-row">
                            <ButtonComponent buttontext="PREJIT_ZPET_NA_PRIHLASENI" onClick={routeChange} />
                        </Row>
                    </Col>
                ) : zadostData?.email && zadostData?.telefon ? (
                    <>
                        {stav ? (
                            <div>
                                {stav === 'IDEN' ? (
                                    <IDEN zadostData={zadostData} setZadostData={setZadostData} /> // Stav IDEN - uživatel je přesměrován z bank id, na stránce se zobrazí jméno, příjmení a e-mail z Bank ID s podmínkama o získání výpisu. Po odsouhlasení jde uživatel zaplatit.
                                ) : stav === 'OBJED' ? (
                                    <OBJED zadostData={zadostData} /> // Stav OBJED - uživatel potvrdil a odeslal objednávku, byl mu odeslán email o potvrzení nyní se bude uživateli zobrazovat stránka s tlačítkem na platbu a shrnutím
                                ) : stav === 'PLZRUS' ? (
                                    <PLZRUS zadostData={zadostData} /> // Stav PLZRUS - uživatel zrušil platbu, bude mu zobrazen text o zrušené objednávce a o tom, že se bez zaplacení dál nedostane
                                ) : stav === 'PLODLO' ? (
                                    <PLODLO zadostData={zadostData} /> // Stav PLODLO - uživatel odložil platbu, bude mu zobrazen text o odložení a o tom, že se bez zaplacení dál nedostane
                                ) : stav === 'PLZAPL' ? (
                                    <PLZAPL zadostData={zadostData} /> // Stav PLZAPL - uživatel zaplatil, nyní potřebujeme aby se přihlásil přes bankid ze kterého dostaneme rodné číslo
                                ) : stav === 'CEKA' || stav === 'DUPL' || stav === 'ZPRAC' || stav === 'VYPR' ? (
                                    // Stav CEKA - Zobrazí se page s přehledem s informací o tom, že se výpis pro uživatele zpracovává
                                    // Stav DUPL - Duplicitní údaje, uživateli se zobrazí hláška o tom, že bude kontaktován CDCP. Výpis z nezařazeného účtu nemůže být automaticky přidělen bez jeho dalšího upřesnění
                                    // Stav ZPRAC - Zobrazí se page s přehledem a hláškou o tom, že je výpis zpracován. Výpis je možné do určitého data stáhnout přes tlačítko na stránce.
                                    // Stav VYPR - Zobrazí se page s přehledem a hláškou o tom, že platnost výpisu vypršela. Uživatel musí zaplatit za nový výpis pokud ho potřebuje.
                                    <Prehled stav={stav} zadostData={zadostData} />
                                ) : stav === 'PLVRAC' ? (
                                    <TranslateText>STAV_PLVRAC</TranslateText>
                                ) : stav === 'ZRUS' ? (
                                    <TranslateText>STAV_ZRUS</TranslateText>
                                ) : (
                                    <TranslateText>SLUZBA_NEDOSTUPNA</TranslateText> // K vypsani teto zpravy dojde pokud stav nebude aplikaci nijak znam. Opet by k vypsani nemelo dojit BUT
                                    // vzdycky se muze pridat nejakej dalsi stav ze kterim se nepocitalo.
                                )}
                            </div>
                        ) : (
                            <TranslateText>NEZNAMY_STAV</TranslateText> // K vypsani teto zpravy dojde pokud stav neexistuje. Nemelo by dojit BUT vzdycky muze nastat situace kde se neco z*sere, BE prestane vracet stav a aplikace by zbytecne padala :D
                        )}
                    </>
                ) : (
                    <VypisKontaktniUdaje zadostData={zadostData} />
                )}
            </LoadingWrapper>
        </StatementWrapper>
    );
};

export default Zadost;
